type OnLoadHandler = (value: void) => void;

type PromisifyLoad = (
  loadFunction: (config: Record<string, unknown> | string, onLoad: OnLoadHandler, onError?: OnLoadHandler) => void,
  config?: Record<string, unknown> | string,
) => () => Promise<void>;

/**
 * Load pixel script as a promise
 */
export const promisifyLoad: PromisifyLoad =
  (loadFunction, config = {}) =>
  () => {
    return new Promise((resolve, reject) => {
      loadFunction(config, resolve, reject);
    });
  };

/**
 * setTimeout as a Promise
 */
export const waitFor = (timeout: number = 0, value?: unknown) => {
  return new Promise(resolve => {
    setTimeout(resolve.bind(null, value), timeout);
  });
};
